import { createSlice } from '@reduxjs/toolkit';

const initialState = { onBody: false, onContent: false, hasTransparency: true };
const loadingSlice = createSlice({
    name: 'loading',
    initialState,
    reducers: {
        showLoading: (state, action) => {
            if (action.payload) state = { ...initialState, ...action.payload}
            if (!state.onBody) state.onContent = true;
            return state;
        },
        hideLoading: (state, action) => initialState
    }
});

export const { hideLoading, showLoading } = loadingSlice.actions;

export default loadingSlice.reducer;
